module.exports = __webpack_public_path__ + "img/3_b.c77dc010.jpg";